import { render, staticRenderFns } from "./waterWenStatistics-jinkou.vue?vue&type=template&id=361764fc&"
import script from "./waterWenStatistics-jinkou.vue?vue&type=script&lang=js&"
export * from "./waterWenStatistics-jinkou.vue?vue&type=script&lang=js&"
import style0 from "./waterWenStatistics-jinkou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports